import axios from "axios";
import { useEffect, useState } from "react";
import httpClient from "../utilis/jwtRequest";

export default function useItemsFetch(itemsUrl, query, page, filterBy) {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [hasMore, setHasMore] = useState(true);

  const getOptionsFromResult = (items) => {
    return items.map((item) => ({ label: item[filterBy], value: item.id }));
  };
  const createRequestURL = () => {
    return `${itemsUrl}?page=${page}&${filterBy}=${query}`;
  };

  useEffect(() => {
    setOptions([]);
    setHasMore(true);
  }, [query]);

  useEffect(() => {
    if (!hasMore) return;

    setLoading(true);

    let cancel;

    const URL = createRequestURL();

    httpClient
      .get(URL, {
        cancelToken: new axios.CancelToken((c) => (cancel = c)),
      })
      .then((res) => {
        setOptions((prevPlaces) => [
          ...prevPlaces,
          ...getOptionsFromResult(res.data.results),
        ]);
        setHasMore(res.data.next !== null);
        setLoading(false);
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          return;
        }
      });

    return () => cancel();
  }, [query, page, hasMore]);

  return { loading, options, hasMore };
}
